import React from 'react';
import PropTypes from 'prop-types';
import { createContainer } from 'components/common/helpers/containerComponentCreator';

import { Container, ContentContainer, IconContainer, Header, Body } from './ContentBlock.styled';

export const ContentBlock = ({ contentRef, children, role, tabIndex, ariaLabel }) => {
  const { Icon, Content, Title } = getChildrenObject(children);
  return (
    <Container ariaLabel={ariaLabel} role={role} tabIndex={tabIndex} innerRef={contentRef}>
      <Header>
        <IconContainer>{Icon}</IconContainer>
        {Title}
      </Header>
      {Content && (
        <Body>
          <ContentContainer tabIndex={tabIndex}>{Content}</ContentContainer>
        </Body>
      )}
    </Container>
  );
};

ContentBlock.propTypes = {
  isCorrect: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  value: PropTypes.string,
  contentRef: PropTypes.func,
  role: PropTypes.string,
  tabIndex: PropTypes.number,
  ariaLabel: PropTypes.string
};

const typeNames = {
  icon: 'icon',
  title: 'title',
  content: 'content'
};
ContentBlock.Icon = createContainer(typeNames.icon);
ContentBlock.Title = createContainer(typeNames.title);
ContentBlock.Content = createContainer(typeNames.content);

ContentBlock.propTypes = {
  title: PropTypes.string,
  children: PropTypes.arrayOf(children => {
    const childrenObj = getChildrenObject(children);

    if (!childrenObj.Icon) {
      return new Error(`ContentBlock: Invalid Prop children, must contain ContentBlock.Icon`);
    }
    if (!childrenObj.Title) {
      return new Error(`Page: Invalid Prop children, must contain ContentBlock.Title`);
    }
  }).isRequired
};

function getChildrenObject(children) {
  return React.Children.toArray(children).reduce((acc, child) => {
    switch (child.type.typeName) {
      case typeNames.icon: {
        acc.Icon = child;
        break;
      }
      case typeNames.content: {
        acc.Content = child;
        break;
      }
      case typeNames.title: {
        acc.Title = child;
        break;
      }
      default: {
        break;
      }
    }
    return acc;
  }, {});
}

export default ContentBlock;
